import FinanceInvoice from "./FinanceInvoice";


const FinanceInvoiceConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/financeInvoice',
      element: <FinanceInvoice />,
    },
    
  ],
};

export default FinanceInvoiceConfig;
